import ZApiService from './ZApiService';
import { IImage } from '@/common/interfaces/image.interface';

export default class ImageService {
  private zApiService: ZApiService;

  constructor(zApiService: ZApiService) {
    this.zApiService = zApiService;
  }

  public async postImage(image: IImage): Promise<IImage> {
    if(image.imageKey) {
      await this.deleteImage(image.imageKey);
    }
    return this.zApiService.postImage(image.imageUrl as File);
  }

  public async deleteImage(key: string): Promise<void> {
    await this.zApiService.deleteImage(key);
  }
}
